<template>
  <div class="contain">
    <div class="layout-login">
      <p class="logo-login"><img src="../assets/images/logo-login.png"
             class="img-logo-login"></p>
      <div class="form-login">
        <input type="text"
               placeholder="请输入账号"
               class="text-login icon-user-login"
               v-model="username">
        <input type="password"
               placeholder="请输入密码"
               class="text-login icon-password-login"
               v-model="password">
        <button class="btn-login"
                @click="login">登录</button>
      </div>
    </div>
  </div>
</template>

<script>
import loginModel from '../api/model/login'

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
    }
  },
  methods: {
    async login() {
      if (this.username == '' || this.password == '') {
        this.$toast('请输入用户名和密码')
      } else {
        const res = await loginModel.login({
          username: this.username,
          password: this.password,
        })
        if (res.success) {
          console.log(res.data)
          this.$store.dispatch('userAbout/setUser', res.data)
          localStorage.setItem('BosUser', JSON.stringify(res.data))
          this.$router.push({ path: '/home' })
        } else {
          this.$toast(res.msg)
        }
      }
    },
  },
}
</script>

<style scoped>
</style>